import { makePostRequest } from "../helpers"

export const activateDoctor = async (doctorId: string) => {
    const result = await makePostRequest(`api/doctors/${doctorId}/activate`, {});

    return result;
}

export const deactivateDoctor = async (doctorId: string) => {
    const result = await makePostRequest(`api/doctors/${doctorId}/deactivate`, {});

    return result;
}